import { Link } from 'react-router-dom';

const MONO = "'IBM Plex Mono', monospace";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1a1a1a] text-white mt-32">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-20 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 lg:gap-16">

          {/* Brand */}
          <div className="space-y-5">
            <Link to="/" className="inline-block">
              <span
                className="text-xl font-semibold tracking-tight"
                style={{ fontFamily: "'Bodoni Moda', Georgia, serif" }}
              >
                FashionSpyder
              </span>
            </Link>
            <p className="text-sm text-white/50 leading-relaxed">
              Aesthetic-driven talent intelligence for the global fashion industry.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-semibold mb-6 uppercase tracking-widest text-white/40" style={{ fontFamily: MONO }}>
              Product
            </h4>
            <ul className="space-y-3.5">
              {[
                { to: '/gallery',       label: 'Spy Gallery' },
                { to: '/ai-matchmaker', label: 'AI Matchmaker' },
                { to: '/pricing',       label: 'Pricing' },
                { to: '/register',      label: 'Get Started' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/50 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold mb-6 uppercase tracking-widest text-white/40" style={{ fontFamily: MONO }}>
              Company
            </h4>
            <ul className="space-y-3.5">
              {[
                { to: '/about',      label: 'About Us' },
                { to: '/for-talent', label: 'For Talent' },
                { to: '/contact',    label: 'Contact' },
                { to: '/faq',        label: 'FAQ' },
                { to: '/newsletter', label: 'Newsletter' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/50 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold mb-6 uppercase tracking-widest text-white/40" style={{ fontFamily: MONO }}>
              Legal
            </h4>
            <ul className="space-y-3.5">
              {[
                { to: '/privacy',  label: 'Privacy Policy' },
                { to: '/cookies',  label: 'Cookie Policy' },
                { to: '/terms',    label: 'Terms of Service' },
              ].map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/50 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-xs text-white/30" style={{ fontFamily: MONO }}>
            © {new Date().getFullYear()} FashionSpyder — All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
